import React from "react";
import { DrawerInfo } from "../../../components/drawerInfo/DrawerInfo.Main";
import { ContextLanguage } from "../../../context/Context.Language";
import { SYMBOL_CURRENCY } from "../../../utils/useConstants";
import { STATE_CONSTANTS_PROGRAM } from "../../../utils/useConstantState";
import { FunctionGetPathUrl } from "../../../utils/useFunction";
import { ICON_INFO } from "../../../utils/useIcons";
import { useIsMobile } from "../../../utils/useIsMobile";
import {
  mock_iron_addon_info,
  mock_mywash_s_package,
} from "../../../utils/useMockData";
import {
  STYLE_ACTIVE_ADDON,
  STYLE_ACTIVE_ADDON_MYIRON,
  STYLE_ACTIVE_ADDON_MYSHOES,
  STYLE_ACTIVE_ADDON_MYWASH,
  STYLE_COLSPAN_ADDONS,
  STYLE_DES_ADDON,
  STYLE_GRID_ADDONS,
  STYLE_HOVER_BLUE,
  STYLE_PRIZE_ADDON,
  STYLE_TITLE_ADDON,
} from "../../../utils/useStyle";
import ProgramClickAddOn from "../functions/Program.ClickAddOn";

const ProgramAddons = ({ row, setSelect, size, type }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  // const isActive =
  //   selected?.findIndex((item) => {
  //     return item?._id === row?._id;
  //   }) >= 0;

  const isActive = row?.isSelected || false;

  const FunctionCheckColorType = (input) => {
    if (input === STATE_CONSTANTS_PROGRAM.MY_WASH) {
      return STYLE_ACTIVE_ADDON_MYWASH;
    } else if (input === STATE_CONSTANTS_PROGRAM.MY_SHOE) {
      return STYLE_ACTIVE_ADDON_MYSHOES;
    } else if (input === STATE_CONSTANTS_PROGRAM.MY_IRON) {
      return STYLE_ACTIVE_ADDON_MYIRON;
    } else if (input === STATE_CONSTANTS_PROGRAM.MY_DRY) {
      return STYLE_GRID_ADDONS;
    } else {
      return STYLE_GRID_ADDONS;
    }
  };

  return (
    <div>
      <div
        onClick={(e) => {
          e.stopPropagation();
          ProgramClickAddOn(row, setSelect, row?.type);
        }}
        className={` ${
          isActive ? `${FunctionCheckColorType(type)}` : STYLE_GRID_ADDONS
        }  w-full relaive `}
        // className=" grid grid-cols-12 w-full "
      >
        <div className=" flex gap-[10px] items-center">
          <img
            src={FunctionGetPathUrl(row?.icon_key)}
            className=" w-w_53 h-h_53 "
          />
          <div className="">
            <div className="flex items-center gap-1 ">
              <div className={`${STYLE_TITLE_ADDON(language)}`}>
                {row?.name}
              </div>
              <ICON_INFO
                className={`w-[18px] text-laundry-gray-100 ${STYLE_HOVER_BLUE} ${
                  language === "TH" && "-mt-1"
                } `}
                onClick={(e) => {
                  e.stopPropagation();
                  setIsOpen(true);
                }}
              />
            </div>

            <div className={`${STYLE_DES_ADDON(language)}`}>
              {row?.description}
            </div>
          </div>
        </div>
        <div className=" absolute right-6  md:static ">
          <div className={STYLE_PRIZE_ADDON(language)}>
            +<span className="font-NotoSansThai">{SYMBOL_CURRENCY}</span>
            {row?.price ? row?.price : row[size]}
          </div>
        </div>
      </div>

      <DrawerInfo
        open={isOpen}
        setOpen={setIsOpen}
        image={FunctionGetPathUrl(row?.image_key_desktop)}
        imageMobile={FunctionGetPathUrl(row?.image_key_mobile)}
        title={row?.name}
        description={row?.addon_description}
        description2={row?.addon_description_2}
      />
    </div>
  );
};

export default ProgramAddons;
